import type { Session } from '@supabase/supabase-js';

const API_BASE_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1`;
const ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export function fetchWithAuth(
  url: string,
  session: Session | null,
  options: RequestInit = {}
): Promise<Response> {
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> | undefined),
    apikey: ANON_KEY,
  };

  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  } else {
    headers['Authorization'] = `Bearer ${ANON_KEY}`;
  }

  const resolvedUrl = url.startsWith('/api/')
    ? `${API_BASE_URL}${url}`
    : url;

  return fetch(resolvedUrl, {
    ...options,
    headers,
    cache: (options.cache as RequestCache) ?? 'no-store',
  });
}
